<template>
    <v-dialog
        v-model="showDialog"
        :disabled="disabled"
        max-width="500"
        persistent
        class="customer-link-accounts flex-none"
    >
        <template #activator="{ on }">
            <div v-on="on" class="customer-link-accounts-btn">
                <v-tooltip bottom>
                    <template #activator="{ on }">
                        <v-btn
                            v-on="on"
                            v-bind="$attrs"
                            outlined
                            :disabled="disabled"
                        >
                            <v-icon class="mr-2">mdi-link-variant-plus</v-icon> Konto verknüpfen
                        </v-btn>
                    </template>
                    <span>Konto verknüpfen</span>
                </v-tooltip>
            </div>
        </template>
        <v-card>
            <v-card-title
                class="headline"
                primary-title
            >
                Konto verknüpfen
            </v-card-title>
            <v-card-text>
                <p class="mb-2">
                    Die Verknüpfung von Kundenkonten erfolgt über Produkte. Produkte mit zuteilbaren Konten können hier ausgewählt werden.
                    Sollte für die E-Mailadresse bereits ein Kunde existieren, so wird sein Kundenkonto automatisch verknüpft und das Produkt an ihn übertragen.
                    Andernfalls wird ein neues Kundenkonto erstellt und anschließend verknüpft.
                </p>
                <v-form v-on:submit.prevent ref="form" v-model="valid">
                    <v-select
                        :value="salutation"
                        @input="setSalutation"
                        :disabled="loading"
                        :items="salutations"
                        :rules="rules.salutation"
                        label="Anrede"
                    ></v-select>
                    <v-text-field
                        :value="firstname"
                        @input="setFirstname"
                        :disabled="loading"
                        @keyup.enter="submit"
                        :rules="rules.firstname"
                        label="Vorname"
                    ></v-text-field>
                    <v-text-field
                        :value="lastname"
                        @input="setLastname"
                        :disabled="loading"
                        @keyup.enter="submit"
                        :rules="rules.lastname"
                        label="Nachname"
                    ></v-text-field>
                    <v-text-field
                        :value="email"
                        @input="setEmail"
                        :disabled="loading"
                        @keyup.enter="submit"
                        :rules="rules.email"
                        label="E-Mailadresse"
                    ></v-text-field>
                    <v-checkbox
                        @change="setSkipMailing"
                        value="on"
                        :checked="skipMailing"
                        label="Keine E-Mail versenden"
                    ></v-checkbox>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="warning"
                    outlined
                    @click="abort"
                    :disabled="loading"
                >Abbrechen</v-btn>
                <v-btn
                    color="success"
                    outlined
                    :loading="loading"
                    :disabled="loading || !valid"
                    @click="link"
                >
                    Konten verknüpfen
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>

import {
    mapState,
    mapActions,
    mapMutations,
} from 'vuex';

export default {
    name: 'LinkAccountsBtn',
    props: ['ssoId', 'disabled', 'orderId', 'position'],
    data() {
        return {
            salutations: ['Herr', 'Frau', 'Firma'],
            showDialog: false,
            processing: false,
            valid: false,
            rules: {
                salutation: [
                    v => this.salutations.indexOf(v) > -1 || 'Ungültige Anrede',
                ],
                firstname: [
                    v => !!v || 'Vorname muss gesetzt sein.',
                    v => v.length <= 35 || 'Vorname darf maximal 35 Zeichen lang sein.',
                ],
                lastname: [
                    v => !!v || 'Nachname muss gesetzt sein.',
                    v => v.length <= 35 || 'Nachname darf maximal 35 Zeichen lang sein.',
                ],
                email: [
                    v => !!v || 'Email muss gesetzt sein.',
                    v => /.+@.+/.test(v) || 'Email muss gültig sein.',
                    v => v.length <= 240 || 'Email darf maximal 240 Zeichen lang sein.',
                ],
            },
        };
    },
    computed: {
        ...mapState('customerLinkAccounts', [
            'loading',
            'email',
            'firstname',
            'lastname',
            'salutation',
            'skipMailing',
        ]),
    },
    methods: {
        abort() {
            this.$emit('close');
            this.showDialog = false;
            this.snackInfo('Das verknüpfen der Konten wurde abgebrochen.');
        },
        link() {
            this.$refs.form.validate();
            if (this.valid && this.orderId) {
                this.processing = true;
                this.linkAccounts({ ssoId: this.ssoId, orderId: this.orderId, position: this.position })
                    .then(() => {
                        this.$emit('close');
                        this.snackSuccess('Die Konten wurden verknüpft.');
                        this.showDialog = false;
                    })
                    .catch(() => {
                        this.snackError('Das Konten konnten nicht verknüpft werden.');
                    })
                    .finally(() => {
                        this.processing = false;
                    });
            }
        },
        ...mapActions('customerLinkAccounts', ['linkAccounts']),
        ...mapMutations('customerLinkAccounts', ['resetState', 'setFirstname', 'setLastname', 'setSalutation', 'setEmail', 'setSkipMailing']),
        ...mapMutations('snackbar', {
            snackError: 'error',
            snackSuccess: 'success',
            snackInfo: 'info',
        }),
    },
};
</script>
<style scoped lang="scss">
    .customer-link-accounts-btn {
        display: block;
    }
</style>
